import { Box, Flex, Text } from '@chakra-ui/react';
import { Badge } from '@morressier/alembic';
import { IUAD } from '@publishing-engine/domain/models';
type ReportCardProps = {
  UADEntry: IUAD & {
    title?: string;
    risk?: string;
  };
};
type Severity = 'LOW' | 'MEDIUM' | 'HIGH';
const severityBadgeMap: Record<Severity, 'neutral' | 'attention' | 'caution'> =
  {
    LOW: 'neutral',
    MEDIUM: 'attention',
    HIGH: 'caution'
  };
const ReportCard = ({ UADEntry }: ReportCardProps) => {
  return (
    <Box
      backgroundColor={'white'}
      borderWidth="1px"
      borderRadius="md"
      p={3}
      mb={4}
      mx={3}
      my={2}
    >
      <Flex gap={2} align="center" lineHeight={'base'} mb={2}>
        <Text textStyle={'headingOverline'} fontWeight={'semibold'}>
          {UADEntry.title}{' '}
          <Box as="span" color={'gray.300'}>
            |
          </Box>
        </Text>
        <Text textStyle={'headingOverline'} fontWeight={'semibold'}>
          {UADEntry.manuscriptId}
        </Text>{' '}
        <Box as="span" color={'gray.300'}>
          |
        </Box>
        <Badge
          variant={
            (UADEntry.risk && severityBadgeMap[UADEntry.risk as Severity]) ||
            'neutral'
          }
        >
          <Text fontSize="xx-small" lineHeight={'base'}>
            {UADEntry.risk}
          </Text>
        </Badge>{' '}
      </Flex>
      {UADEntry.details.map(EntryDetail => {
        return (
          <>
            <Text fontSize="sm" mt={2}>
              {EntryDetail.title}
            </Text>
          </>
        );
      })}
    </Box>
  );
};

export default ReportCard;
{
  /* <Text fontSize="sm" color="gray.600" mb={2}>
        Submitting author: Mahjaha Dehghan
      </Text>

      <Text fontSize="sm" mb={2}>
        9 submissions in this journal by different authors...
      </Text>

      <Text fontSize="sm" color="gray.600">
        118 submissions outside of this journal.
      </Text>

      <Text fontSize="sm" mt={2}>
        First occurrence: Dec 28, 2023
      </Text>
      <Text fontSize="sm">Latest occurrence: Dec 15, 2025</Text> */
}
